import {Map, List} from "immutable";

export function indexSurchargeProducts(surcharges = List()) {
  return surcharges.reduce((acc, item) => {
    return acc.set(item.get("productSku"), indexSurchargeCurrencies(item.get("surcharge"), List()));
  }, Map());
}

function indexSurchargeCurrencies(surcharge) {
  return surcharge.reduce((acc, item) => {
    return acc.set(item.get("currency"), item.get("value"));
  }, Map());
}

function getProductSurcharge(indexedSurcharges, sku, currency) {
  return indexedSurcharges.getIn([sku, currency], 0);
}

// Returns map of {products: int, surcharges: int, total: int, currency: currency}
export function getSubscriptionTotals(products, indexedSurcharges = Map()) {
  let _surcharge = 0;
  let currency = products.getIn([0, "currency"], "");
  let totals = products.reduce((acc, product) => {
    _surcharge = product.get("quantity") * getProductSurcharge(indexedSurcharges, product.get("productSku"), product.get("currency"));
    return acc.set("surcharges", acc.get("surcharges") + _surcharge)
              .set("products", acc.get("products") + parseInt(product.get("total"), 10))
  }, Map({products: 0, surcharges: 0}));

  return Map({
    products: totals.get("products"),
    surcharges: totals.get("surcharges"),
    total: totals.get("products") + totals.get("surcharges"),
    currency: currency
  });
}